module.exports = __webpack_public_path__ + "img/icon-vkreklama.b4e1710a.svg";